exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags{flex:1;margin-bottom:0!important}.tags .tag{margin:0 8px 8px 0;text-transform:capitalize}.tag{cursor:pointer}.tag img{margin-left:8px}", ""]);

// exports
